import React, { useState, useEffect } from 'react';
import apiService from '../../services/apiService';
import DomainList from '../../components/organic-seo/DomainList';
import DomainProfileView from '../../components/organic-seo/DomainProfileView';
import OrganicSeoTasksManager from '../../components/organic-seo/OrganicSeoTasksManager';
import SeoHealthConsole from '../../components/organic-seo/SeoHealthConsole';
import SeoHealthLogsTable from '../../components/organic-seo/SeoHealthLogsTable';
import './OrganicSEOPage.css';

const OrganicSEOPage = () => {
    const [domains, setDomains] = useState([]);
    const [selectedDomain, setSelectedDomain] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        fetchDomains();
    }, []);

    const fetchDomains = async () => {
        setLoading(true);
        try {
            const data = await apiService.makeRequest('/organic-seo/domains');
            setDomains(data || []);
        } catch (error) {
            console.error("Failed to fetch domains:", error);
        } finally {
            setLoading(false);
        }
    };

    const handleSelectDomain = (domain) => {
        setSelectedDomain(domain);
    };

    return (
        <div className="organic-seo-page">
            <header className="page-header" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <div>
                    <h1>🌐 Organic SEO Command Center</h1>
                    <p>Manage {domains.length} connected WordPress sites with AI Agents</p>
                </div>
                <div className="flex gap-2">
                    <a 
                        href="/admin/brain?tab=web-studio" 
                        className="bg-blue-500 hover:bg-blue-600 text-white px-6 py-2 rounded-lg font-bold shadow-sm transition flex items-center gap-2"
                        style={{ textDecoration: 'none', fontSize: '15px' }}
                    >
                        🎨 Open Katifi Web Studio
                    </a>
                </div>
            </header>

            <div className="organic-seo-layout">
                <div className="sidebar">
                    <DomainList 
                        domains={domains} 
                        onRefresh={fetchDomains} 
                        onSelect={handleSelectDomain}
                        selectedDomain={selectedDomain}
                    />
                </div>
                
                <div className="main-content">
                    {selectedDomain ? (
                        <>
                            <DomainProfileView domain={selectedDomain} />
                            <SeoHealthConsole domainId={selectedDomain.id} />
                            <div className="bg-white rounded-xl shadow-sm border border-gray-200 p-6 mb-8 w-full">
                                <OrganicSeoTasksManager domain={selectedDomain} />
                            </div>
                            <SeoHealthLogsTable domainId={selectedDomain.id} />
                        </>
                    ) : (
                        <div className="empty-state">
                            <h3>Select a domain to view profile and tasks</h3>
                        </div>
                    )}
                </div>
            </div>

        </div>
    );
};

export default OrganicSEOPage;
